import cn from "classnames";
import * as React from "react";
import styles from "./style.module.less";
export interface DataTableRowProps {
    displayNoBorder?: boolean;
    displayNoBottomBorderForLastRow?: boolean;
    className?: string;
    disabled?: boolean | null;
    onClick?: (e: React.MouseEvent<HTMLTableRowElement>) => void;
    children?: React.ReactNode;
}
export class DataTableRow extends React.Component<DataTableRowProps> {
    render() {
        const { displayNoBorder, className, disabled, displayNoBottomBorderForLastRow, ...otherProps } = this.props;
        return (<tr {...otherProps} className={cn(className, styles.dataTableRow, displayNoBorder ? styles.noBorder : "", displayNoBottomBorderForLastRow ? styles.noBottomBorderForLastRow : "", disabled ? styles.disabled : "")}>
                {this.props.children}
            </tr>);
    }
    static displayName = "DataTableRow";
}
